import { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { scroller } from "react-scroll";
import { useParams, useHistory, useLocation } from "react-router-dom";
import logoHeader from "../../assets/logo.png";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";
import { saveTrackingParams } from "../../utils/utmTracker";
import { buildRouteWithUtms, saveUtmParams } from "../../config/whatsappConfig";

const NAV_ITEMS = [
  { label: "Inicio", sectionId: "inicio", route: "/todos" },
  { label: "Venta Directa", sectionId: "convencional", route: "/convencional" },
  { label: "Financiaciones", sectionId: "financiaciones", route: "/convencional" },
  { label: "Fiat Plan", sectionId: "plan", route: "/plan" },
];

const Header = () => {
  const { openConsultaForm } = useWhatsAppConsulta();
  const location = useLocation();
  const history = useHistory();
  const { tipo } = useParams();

  useEffect(() => {
    if (
      tipo !== "todos" &&
      tipo !== "convencional" &&
      tipo !== "plan" &&
      tipo !== "preventa" &&
      tipo !== "adjudicado" &&
      tipo !== "adjudicados" &&
      tipo !== undefined
    ) {
      saveTrackingParams();
      saveUtmParams();
      history.push(buildRouteWithUtms("/todos", location.search));
    }
  }, [history, tipo]);

  const handlePedirPresupuesto = () => {
    window.dataLayer.push({
      event: "solicitud_presupuesto",
    });
    openConsultaForm();
  };

  const handleNavClick = ({ sectionId, route }) => {
    const search = location.search;
    const currentTipo = tipo || "todos";
    const targetTipo = route.replace("/", "") || "todos";

    if (currentTipo !== targetTipo) {
      history.push(buildRouteWithUtms(route, search));
    }

    setTimeout(
      () => {
        scroller.scrollTo(sectionId, { smooth: true, duration: 500, offset: -10 });
      },
      currentTipo !== targetTipo ? 350 : 0
    );
  };

  return (
    <Container fluid className="header">
      <Container>
        <Row className="row-header align-items-center">
          <Col md={4} xs={12} className="text-sm-start text-center pt-2 pb-2">
            <Link to={buildRouteWithUtms("/todos", location.search)}>
              <img src={logoHeader} alt="Montironi Fiat" className="img-fluid header-logo" />
            </Link>
          </Col>
          <Col
            md={8}
            xs={12}
            className="text-sm-end text-center pt-2 pb-2 justify-content-md-end justify-content-center d-md-flex d-none align-items-center gap-2"
          >
            <nav className="d-flex align-items-center flex-wrap justify-content-md-end justify-content-center">
              {NAV_ITEMS.map((item) => (
                <button
                  key={item.label}
                  type="button"
                  className="link-header px-sm-3"
                  onClick={() => handleNavClick(item)}
                >
                  {item.label}
                </button>
              ))}
            </nav>
            <Button className="btn-fiat-corporate ms-md-2" onClick={handlePedirPresupuesto}>
              Solicitar cotización
            </Button>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Header;
